"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMutableQueue = exports.createImmutableQueue = void 0;
/**
 * Create an immutable queue. Adding and removing items will return a new queue.
 */
function createImmutableQueue(entries) {
    if (entries === void 0) { entries = []; }
    return {
        add: function (data) {
            var copy = entries.slice();
            copy.push({
                id: String(Date.now()),
                data: data,
            });
            return createImmutableQueue(copy);
        },
        addById: function (id, data) {
            var matchIndex = entries.findIndex(function (n) { return n.id === id; });
            var copy = entries.slice();
            if (matchIndex > -1) {
                copy.splice(matchIndex, 1, {
                    id: id,
                    data: data,
                });
            }
            else {
                copy.push({
                    id: id,
                    data: data,
                });
            }
            return createImmutableQueue(copy);
        },
        remove: function (id) {
            return createImmutableQueue(entries.filter(function (n) { return n.id !== id; }));
        },
        removeAll: function () {
            return createImmutableQueue();
        },
        entries: entries,
    };
}
exports.createImmutableQueue = createImmutableQueue;
/**
 * Create a mutable queue. Adding and removing items will return the same queue so you can
 * assert that changes we made.
 */
function createMutableQueue(initialValue) {
    if (initialValue === void 0) { initialValue = []; }
    var entries = initialValue;
    var updateEntries = function (queue) {
        entries.splice(0, entries.length);
        entries.push.apply(entries, queue.entries);
    };
    return {
        addById: function (id, data) {
            var queue = createImmutableQueue(entries).addById(id, data);
            updateEntries(queue);
            return this;
        },
        add: function (data) {
            var queue = createImmutableQueue(entries).add(data);
            updateEntries(queue);
            return this;
        },
        remove: function (id) {
            var queue = createImmutableQueue(entries).remove(id);
            updateEntries(queue);
            return this;
        },
        removeAll: function () {
            var queue = createImmutableQueue(entries).removeAll();
            updateEntries(queue);
            return this;
        },
        entries: entries,
    };
}
exports.createMutableQueue = createMutableQueue;
